import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

const root = createRoot(document.getElementById("root")!);

//Show loading text till config json is loaded
root.render(
  <div
    style={{
      alignItems: "center",
      display: "flex",
      height: "100vh",
      justifyContent: "center",
    }}
  >
    Loading
  </div>,
);

async function startApp() {
  const response = await fetch("/config.json");

  if (!response.ok) {
    throw new Error(`Unable to load application configuration: ${response.status}`);
  }

  window.__APP_CONFIG__ = await response.json();

  // Load App after APP_CONFIG has been initialized so config modules observe
  // the runtime value during module evaluation.
  const { App } = await import("./App");

  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void startApp();
